import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'

import { get } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { Container } from '../../../components/Container'
import { NewVerticalStepIndicator } from '../../../components/NewVerticalStepIndicator'
import { useLazyApiData, useStores } from '../../../data/store'
import { getFormattedDate } from '../../../network/eosCreateWorkItem'
import { compareArray, zoomOutIfRequire } from '../../../utils'
import { STORE_MERCHANT } from '../../../utils/constants'
import { CheckerDetailsFooter } from '../CheckerDetails/CheckerDetailsFooter'
import { SCREEN_MAAPPER_CHECKER_MY_TASK } from '../MyOnboardedEntityQueue'
import { EntityOnboardingForm } from '../OnboardEntity/EntityOnboardingForm'
import { EntityOnboardingHeader } from '../OnboardEntity/EntityOnboardingHeader'
import { FullScreenLoader } from '../OnboardEntity/comps/FullScreenLoader'

const nativeID = 'searchDetails'

const modifiedMapperMetadata = (usertype, editable) => {
  switch (usertype) {
    case 'MAKER_SEARCH_ENTITY':
      if (editable) {
        return {
          ...SCREEN_MAAPPER_CHECKER_MY_TASK[usertype],
          totalFilledStep: 8,
        }
      }
      break
    case 'RISK_MAKER_SEARCH_ENTITY':
      if (editable) {
        return {
          ...SCREEN_MAAPPER_CHECKER_MY_TASK[usertype],
          totalFilledStep: 10,
        }
      }
      break
  }
  return SCREEN_MAAPPER_CHECKER_MY_TASK[usertype]
}

const SearchEntityDetails = ({ navigation, route: { params } }) => {
  const {
    getSearchEntityInitData,
    accessConfig,
    fetchEosEntityDetailsAsync,
    updateExistingEntityAsync,
    updateExistingEntityForInteractionAsync,
  } = useStores((store) => ({
    getSearchEntityInitData: store.entityOnboarding.getSearchEntityInitData,
    fetchEosEntityDetailsAsync: store.entityOnboarding.fetchEosEntityDetailsAsync,
    updateExistingEntityAsync: store.entityOnboarding.updateExistingEntityAsync,
    updateExistingEntityForInteractionAsync: store.entityOnboarding.updateExistingEntityForInteractionAsync,
    accessConfig: JSON.parse(store.user.accessConfig),
  }))
  const formRef = React.useRef(null)
  const isMaker = get(accessConfig.entity_management_service, ['ems_config', 'create', 'isAccessible'], false)
  const isRiskMaker = get(accessConfig.entity_management_service, ['risk', 'create', 'isAccessible'], false)
  const getUserType = useCallback(() => {
    if (isMaker && isRiskMaker) {
      return 'RISK_MAKER_SEARCH_ENTITY'
    } else if (isMaker) {
      return 'MAKER_SEARCH_ENTITY'
    } else if (isRiskMaker) {
      return 'RISK_MAKER_SEARCH_ENTITY'
    }
    return 'DEFAULT_SEARCH_ENTITY'
  }, [isMaker, isRiskMaker])

  const [USER_TYPE, setUserType] = useState(getUserType())
  const [editable, setEditable] = useState(false)
  const [isEditAsMakerEditable, setEditAsMaker] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)
  const [requestId, setRequestId] = useState(`UPDATE-${getFormattedDate()}`)
  const [formValidationStatus, setFormValidationStatus] = useState(
    SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.onBoardingSteps?.map(() => true),
  )
  const [previousCallInfo, setPreviousCallInfo] = useState({
    lastRequest: {},
    lastDedupeData: {},
  })

  const [lazyGetSearchEntityInitData, getSearchEntityInitDataHandler] = useLazyApiData(getSearchEntityInitData)
  const [lazyGetSearchEntityForEdit, getSearchEntityForEditHandler] = useLazyApiData(fetchEosEntityDetailsAsync)
  const [lazyUpdateExistingEntity, updateExistingEntityHandler] = useLazyApiData(updateExistingEntityAsync)
  const [lazyUpdateExistingEntityForInteraction, updateExistingEntityForInteractionHandler] = useLazyApiData(
    updateExistingEntityForInteractionAsync,
  )

  const selectedEntityDetails = params?.item || JSON.parse(localStorage.getItem('queryParams'))?.item

  console.log('selectedEntityDetails', selectedEntityDetails)

  useEffect(() => {
    setUserType(getUserType())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRiskMaker, isMaker])

  useEffect(() => {
    zoomOutIfRequire(nativeID)
    lazyGetSearchEntityInitData(selectedEntityDetails)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    params && localStorage.setItem('queryParams', JSON.stringify(params))
  }, [params])

  useEffect(() => {
    if (getSearchEntityForEditHandler?.state === 'fulfilled') {
      if (isMaker && isRiskMaker && USER_TYPE === 'MAKER_SEARCH_ENTITY') {
        setEditAsMaker(!isEditAsMakerEditable)
      } else {
        setEditable(!editable)
      }
    } else if (getSearchEntityForEditHandler?.state === 'rejected') {
      setUserType(getUserType())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSearchEntityForEditHandler?.state])

  useEffect(() => {
    if (
      updateExistingEntityHandler?.state === 'fulfilled' ||
      updateExistingEntityForInteractionHandler?.state === 'fulfilled'
    ) {
      setPreviousCallInfo({
        lastRequest: {},
        lastDedupeData: {},
      })
      navigation.reset({
        index: 0,
        routes: [{ name: 'makerMyEntityQueue' }],
      })
    } else if (updateExistingEntityHandler?.state === 'rejected') {
      if (updateExistingEntityHandler?.data?.dedupeFound) {
        setPreviousCallInfo({
          lastRequest: updateExistingEntityHandler?.data?.lastRequest,
          lastDedupeData: updateExistingEntityHandler?.data?.dedupeResponse,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateExistingEntityHandler?.state, updateExistingEntityForInteractionHandler?.state])
  const onStepPressed = useCallback((pressedStep: any) => {
    setCurrentStep(pressedStep)
  }, [])

  const toggleEdit = useCallback(() => {
    onStepPressed(1)
    setUserType(getUserType())
    if (!editable) {
      lazyGetSearchEntityForEdit(getSearchEntityInitDataHandler?.data?.applicationId, getUserType())
    } else {
      setEditable(!editable)
    }
  }, [
    editable,
    getSearchEntityInitDataHandler?.data?.applicationId,
    getUserType,
    lazyGetSearchEntityForEdit,
    onStepPressed,
  ])

  const onSubmit = useCallback(
    async (action, comment, internalComment) => {
      console.log('action=', action)
      console.log('comments=', comment)
      if (USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY' && ['SUBMIT_COMMENTS', 'VERIFY_COMMENTS'].includes(action)) {
        lazyUpdateExistingEntityForInteraction(
          getSearchEntityInitDataHandler?.data?.applicationId,
          {
            riskMakerActionType: action,
            commentForOps: comment,
            internalComment,
          },
          requestId,
        )
      } else {
        lazyUpdateExistingEntity(
          {
            editedValues: formRef?.current?.getValues(),
            ...(USER_TYPE === 'MAKER_SEARCH_ENTITY' && { opsMakerActionType: action, comment }),
            ...(USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY' && {
              riskMakerActionType: action,
              commentForOps: comment,
              internalComment,
              applicationId: requestId,
            }),
          },
          getSearchEntityForEditHandler?.data,
          previousCallInfo.lastRequest,
          previousCallInfo.lastDedupeData,
        )
      }
    },
    [
      USER_TYPE,
      getSearchEntityForEditHandler?.data,
      lazyUpdateExistingEntity,
      previousCallInfo.lastDedupeData,
      previousCallInfo.lastRequest,
      getSearchEntityInitDataHandler?.data?.applicationId,
    ],
  )

  const onEditAsMakerPress = useCallback(() => {
    onStepPressed(1)
    setUserType('MAKER_SEARCH_ENTITY')
    if (!isEditAsMakerEditable) {
      lazyGetSearchEntityForEdit(getSearchEntityInitDataHandler?.data?.applicationId, 'RISK_MAKER_SEARCH_ENTITY')
    } else {
      setUserType(getUserType())
      setEditAsMaker(!isEditAsMakerEditable)
    }
  }, [
    getSearchEntityInitDataHandler?.data?.applicationId,
    getUserType,
    isEditAsMakerEditable,
    lazyGetSearchEntityForEdit,
    onStepPressed,
  ])

  const onBackPress = useCallback(() => {
    navigation.reset({
      index: 0,
      routes: [{ name: 'globalSearchEntityList' }],
    })
  }, [navigation])

  const isFormValid = useCallback((values, step) => {
    if (step === 3) {
      if (values.merchantType === STORE_MERCHANT) {
        return true
      }
      if (
        (!values?.authSignatoryPoA_docs_data || values?.authSignatoryPoA_docs_data?.length === 0) &&
        (!values?.authSignatoryPoA_docs_data_jdms || values?.authSignatoryPoA_docs_data_jdms?.length === 0)
      ) {
        return false
      } else if (
        (!values?.authSignatoryPoi_docs_data || values?.authSignatoryPoi_docs_data?.length === 0) &&
        (!values?.authSignatoryPoi_docs_data_jdms || values?.authSignatoryPoi_docs_data_jdms?.length === 0)
      ) {
        return false
      } else if (!values.authSignatoryCity || !values.authSignatoryState) {
        return false
      }
    } else if (step === 4) {
      if (values.merchantType === STORE_MERCHANT) {
        return true
      }
      if (
        (!values?.businessDetailsPob_docs_data || values?.businessDetailsPob_docs_data?.length === 0) &&
        (!values?.businessDetailsPob_docs_data_jdms || values?.businessDetailsPob_docs_data_jdms?.length === 0)
      ) {
        return false
      } else if (!values.city || !values.state) {
        return false
      }
    } else if (step === 6) {
      if (
        (!values?.canceled_check_docs_data || values?.canceled_check_docs_data?.length === 0) &&
        (!values?.canceled_check_docs_data_jdms || values?.canceled_check_docs_data_jdms?.length === 0) &&
        values.merchantType !== STORE_MERCHANT
      ) {
        return false
      }
    }
    return true
  }, [])

  const renderActionButton = useCallback(
    (props: any) => {
      console.log('props=', props)

      const allStepValidationStatus: any[] = props.allStepValidationStatus?.map((item, index) => {
        return item && (USER_TYPE !== 'MAKER_SEARCH_ENTITY' || isFormValid(props?.values, index + 1))
      })

      if (USER_TYPE === 'MAKER_SEARCH_ENTITY') {
        allStepValidationStatus[0] = true
      } else {
        allStepValidationStatus.fill(
          true,
          0,
          editable ? allStepValidationStatus.length - 2 : allStepValidationStatus.length,
        )
      }
      const isChanged = !compareArray(allStepValidationStatus, formValidationStatus)
      if (isChanged) {
        setFormValidationStatus([...allStepValidationStatus])
      }
      const showFooter =
        USER_TYPE !== 'DEFAULT_SEARCH_ENTITY' &&
        (editable || isEditAsMakerEditable || USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY') &&
        modifiedMapperMetadata(USER_TYPE, editable || isEditAsMakerEditable).totalFilledStep === currentStep

      return (
        <CheckerDetailsFooter
          show={showFooter}
          isCurrentFormValid={formValidationStatus.every((isValid) => isValid)}
          editable={editable || isEditAsMakerEditable || USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY'}
          onSubmit={onSubmit}
          commentTitle={USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY' ? 'Risk Maker external comments' : 'Maker comments'}
          internalCommentTitle={
            USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY' ? 'Risk Maker internal comments' : 'Maker internal comments'
          }
          submitActions={SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.submitActions?.filter(
            (item) => item?.key !== 'APPROVE' || editable,
          )}
          showInternalCommentsField={USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY'}
          showUploadFileComp={USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY'}
          merchantId={selectedEntityDetails?.entityId}
          requestId={requestId}
        />
      )
    },
    [USER_TYPE, currentStep, editable, formValidationStatus, isEditAsMakerEditable, isFormValid, onSubmit],
  )

  return (
    <Box h="100%" w="100%" overflow={'hidden'} padding={5}>
      <Box {...styles.container} nativeID={nativeID}>
        <EntityOnboardingHeader
          title={getSearchEntityInitDataHandler?.data?.businessDisplayName}
          entityId={getSearchEntityInitDataHandler?.data?.entityId}
          businessChannel={getSearchEntityInitDataHandler?.data?.businessChannel}
          entityStatus={getSearchEntityInitDataHandler?.data?.status}
          onboardingChannel={getSearchEntityInitDataHandler?.data?.onboardingChannel}
          showBackButton={true}
          showEditAsMaker={isMaker && isRiskMaker}
          toggleEdit={toggleEdit}
          editable={editable}
          showEditButton={USER_TYPE !== 'DEFAULT_SEARCH_ENTITY'}
          onBackPress={onBackPress}
          isEditAsMakerEditable={isEditAsMakerEditable}
          onEditAsMakerPress={onEditAsMakerPress}
        />
        <Box {...styles.innerContainer}>
          <Box w={220}>
            <NewVerticalStepIndicator
              currentStep={currentStep}
              submitState={''}
              formValidationStatus={formValidationStatus}
              steps={SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.onBoardingSteps?.filter(
                (item) =>
                  (item !== 'Risk Settings' && item !== 'Interaction History') ||
                  !isEditAsMakerEditable ||
                  USER_TYPE === 'RISK_MAKER_SEARCH_ENTITY',
              )}
              totalFilledStep={SCREEN_MAAPPER_CHECKER_MY_TASK[USER_TYPE]?.totalFilledStep}
              onStepPressed={onStepPressed}
              type={!editable && !isEditAsMakerEditable ? 'READ_ONLY' : 'DEFAULT'}
            />
          </Box>
          <Container
            isLoading={getSearchEntityInitDataHandler?.state === 'pending'}
            errorMessage={getSearchEntityInitDataHandler?.data?.message}
            emptyMessage={
              getSearchEntityInitDataHandler?.state === 'fulfilled' &&
              getSearchEntityInitDataHandler?.data?.length === 0 &&
              'No Data Found'
            }
            flex={1}
            onRetry={() => lazyGetSearchEntityInitData(selectedEntityDetails)}>
            <EntityOnboardingForm
              formRef={formRef}
              currentStep={currentStep}
              onStepPressed={onStepPressed}
              initialValues={
                (editable || isEditAsMakerEditable) && getSearchEntityForEditHandler?.state === 'fulfilled'
                  ? getSearchEntityForEditHandler?.data
                  : getSearchEntityInitDataHandler?.data
              }
              isEditable={editable || isEditAsMakerEditable}
              fromChekerQueue={true}
              onSubmit={undefined}
              userType={USER_TYPE}
              renderActionButton={renderActionButton}
            />
          </Container>
        </Box>
        <FullScreenLoader
          show={
            getSearchEntityForEditHandler.state === 'pending' ||
            updateExistingEntityHandler?.state === 'pending' ||
            updateExistingEntityForInteractionHandler?.state === 'pending'
          }
        />
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  innerContainer: {
    flexDirection: 'row',
    flex: 1,
  } as BoxProps,
}

export default SearchEntityDetails
